import { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { ArrowLeft, Download, Printer } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function AdminQr() {
  const { user } = useAuth();
  const [lang, setLang] = useState("it");
  const url = `${BASE}/api/menu.pdf?lang=${lang}`;

  const downloadPng = () => {
    const canvas = document.getElementById("qr-canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `qrcode-menu-ristorante-milano-${lang}.png`;
    a.click();
  };

  return (
    <div data-testid="admin-qr-page" className="min-h-screen bg-[#0D0C0A]">
      <style>{`
        @media print {
          body * { visibility: hidden; }
          #qr-print-area, #qr-print-area * { visibility: visible; }
          #qr-print-area { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; background: #ffffff; }
        }
      `}</style>

      <header className="border-b border-[rgba(201,162,101,0.18)] bg-[#171512]/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 lg:px-12 h-[72px] flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Logo className="h-9 w-9" />
            <div>
              <p className="font-cinzel text-sm tracking-[0.25em] text-[#FAF7F2]">QR MENÙ TAVOLI</p>
              <p className="text-[11px] text-[#7A7267]">{user?.email}</p>
            </div>
          </div>
          <a
            href="/admin"
            data-testid="qr-back-to-reservations"
            className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#B0A89C] hover:text-[#C9A265] font-cinzel transition-colors"
          >
            <ArrowLeft size={14} /> Prenotazioni
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-12 py-12 text-center">
        <p className="text-sm text-[#7A7267] leading-relaxed max-w-xl mx-auto">
          Questo QR code apre il menù PDF, sempre aggiornato con i dati del sito.
          Stampalo e mettilo sui tavoli: quando modifichi il menù dall'admin, il PDF si aggiorna da solo
          e il QR resta lo stesso.
        </p>

        <div className="mt-8 inline-flex rounded-full border border-[rgba(201,162,101,0.3)] overflow-hidden">
          {["it", "en"].map((l) => (
            <button
              key={l}
              data-testid={`qr-lang-${l}`}
              onClick={() => setLang(l)}
              className={`px-5 py-2 text-[11px] uppercase tracking-[0.25em] font-cinzel transition-colors duration-300 ${
                lang === l ? "bg-[#C9A265] text-[#0D0C0A]" : "text-[#B0A89C] hover:text-[#C9A265]"
              }`}
            >
              {l === "it" ? "Italiano" : "English"}
            </button>
          ))}
        </div>

        <div id="qr-print-area" className="mt-10 inline-block">
          <div className="bg-white rounded-3xl p-10 shadow-2xl w-[340px]">
            <p className="font-serif-display text-2xl tracking-[0.15em] text-[#1C1814]">RISTORANTE MILANO</p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-[#A98548]">Casale Monferrato</p>
            <div className="my-6 flex justify-center">
              <QRCodeCanvas
                id="qr-canvas"
                data-testid="qr-canvas"
                value={url}
                size={220}
                bgColor="#FFFFFF"
                fgColor="#1C1814"
                level="M"
                includeMargin={false}
              />
            </div>
            <p className="text-sm text-[#1C1814] font-medium">
              {lang === "it" ? "Scansiona per il nostro menù" : "Scan for our menu"}
            </p>
            <p className="mt-1 text-[10px] text-[#6E655A]">Piazza Castello 41 · +39 351 436 9996</p>
          </div>
        </div>

        <p data-testid="qr-url" className="mt-6 text-[11px] text-[#7A7267] break-all max-w-md mx-auto">{url}</p>

        <div className="mt-8 flex items-center justify-center gap-3">
          <button
            data-testid="qr-download-button"
            onClick={downloadPng}
            className="flex items-center gap-2 px-6 py-3 bg-[#C9A265] text-[#0D0C0A] text-xs uppercase tracking-[0.2em] font-semibold font-cinzel rounded-full hover:bg-[#E0B87A] transition-colors duration-300"
          >
            <Download size={14} /> Scarica PNG
          </button>
          <button
            data-testid="qr-print-button"
            onClick={() => window.print()}
            className="flex items-center gap-2 px-6 py-3 border border-[#C9A265] text-[#C9A265] text-xs uppercase tracking-[0.2em] font-cinzel rounded-full hover:bg-[#C9A265] hover:text-[#0D0C0A] transition-colors duration-300"
          >
            <Printer size={14} /> Stampa
          </button>
        </div>
      </main>
    </div>
  );
}
